import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {RootState} from "@/store";
import useCustomPaging from "@/hooks/useCustomPaging";

const useUserVenueSelectFilter = () => {
  const [searchParams] = useSearchParams()
  const [, changeFilterWithoutPage] = useCustomPaging()
  const {venues} = useSelector((rootState: RootState) => rootState.userInfo.state)
  const currentVenueId = searchParams.get('venueId') ?? ''
  
  const getSelectedVenue = () => {
    const found = venues.find(v => v.id === currentVenueId)
    return found
      ? {value: currentVenueId, label: found.name}
      : {value: '', label: 'Semua Venue'}
  }
  const getSelectVenueOption = () => {
    const venuesOptions = venues.map(v => ({
      value: v.id,
      label: v.name
    }))
    return [
      {
        value: '',
        label: 'Semua Venue'
      },
      ...venuesOptions,
    ]
  }
  const handleChangeVenue = (v) => {
    changeFilterWithoutPage('venueId', v.value)
  }
  
  return [
    currentVenueId,
    getSelectedVenue(),
    getSelectVenueOption(),
    handleChangeVenue
  ] as const
}

export default useUserVenueSelectFilter